export default {
      id: "icon--skating-usage",
      viewBox: "0 0 29 25",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--skating-usage",
      toString: function () {
        return this.url;
      }
    }